import { LANGUAGES } from "@enums";
import moment from "moment";
import "moment/locale/br";
import "moment/locale/en-gb";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/pt";
import "moment/locale/ru";
import "moment/locale/th";
import "moment/locale/tr";
import React, { lazy, Suspense } from "react";
import { render } from "react-dom";
import { LocalizeProvider } from "react-localize-redux";
import { Route, Router, Switch } from "react-router-dom";

//lazy load
import "lazysizes";

//i18n
import { addTranslationForLanguage, initialize } from "react-localize-redux";
import br from "./i18n/br.json";
import en from "./i18n/en.json";
import es from "./i18n/es.json";
import fa from "./i18n/fa.json";
import it from "./i18n/it.json";
import pt from "./i18n/pt.json";
import ru from "./i18n/ru.json";
import th from "./i18n/th.json";
import tr from "./i18n/tr.json";

//Layout
//import AppLayout from "./layouts/index.jsx";
//import AppLayout from "./layouts/v2";
//const AppLayout = require(`./layouts/${!!window.V2 ? "v2" : "index.jsx"}`).default;

const ChokwinLayout = lazy(() => import("./layouts/chokwin"));
const V4Layout = lazy(() => import("./layouts/v4"));

const TenantLayout = (props) => {
	if (window.TENANT === "chokwin") {
		return <ChokwinLayout {...props} />;
	}
	return <V4Layout {...props} />;
};

const AppLayout = TenantLayout;

//Pages
const Home = lazy(() => import("./pages/home/index.jsx"));
const HomeV2 = lazy(() => import("./pages/home/v2"));
const HomeV4 = lazy(() => import("./pages/home/v4"));
const HomeChokwin = lazy(() => import("./pages/home/chokwin"));
//const Home = require(`./pages/${!!window.V2 ? "home/v2" : "home/index.jsx"}`).default;

const Sportsbook = lazy(() => import("./pages/sportsbook/index.js"));
const NotFound = lazy(() => import("./pages/notFound.jsx"));
const TVGames = lazy(() => import("./pages/tvGames/index.jsx"));
const Bonus = lazy(() => import("./pages/bonus/index.js"));
const Wiseodds = lazy(() => import("./pages/wiseodds/index.jsx"));
const Security = lazy(() => import("./pages/profile/security.jsx"));
const ChangeEmail = lazy(() => import("./pages/profile/changeEmail.jsx"));
const PrivacyPolicy = lazy(() => import("./pages/docs/privacyPolicy.jsx"));
const GeneralTermsAndCnd = lazy(() => import("./pages/docs/generalTermsAndCnd.jsx"));
const ResponsibleGaming = lazy(() => import("./pages/docs/responsibleGaming.jsx"));
const BizeUlasin = lazy(() => import("./pages/docs/turkish/bizeUlasin.jsx"));
const BizeUlasinReversed = lazy(() => import("./pages/docs/turkish/bizeUlasinReversed.jsx"));
const OdemeYontemleri = lazy(() => import("./pages/docs/turkish/odemeYontemleri.jsx"));
const KullanimSartlari = lazy(() => import("./pages/docs/turkish/kullanimSartlari.jsx"));
const KullanimSartlariReversed = lazy(
	() => import("./pages/docs/turkish/kullanimSartlariReversed.jsx")
);
const SikSorulanSorular = lazy(() => import("./pages/docs/turkish/sikSorulanSorular.jsx"));
const Affiliate = lazy(() => import("./pages/docs/turkish/affiliate.jsx"));
const Hakkimizda = lazy(() => import("./pages/docs/turkish/hakkimizda.jsx"));
const BasindaMarsBahis = lazy(() => import("./pages/docs/turkish/basindaMarsBahis.jsx"));
const AccountsPayoutsAndBonuses = lazy(() => import("./pages/docs/accountPayoutsAndBonuses.jsx"));
const FairnessRNGTestingMethods = lazy(() => import("./pages/docs/fairnessRngTestingMethods.jsx"));
const DisputeResolution = lazy(() => import("./pages/docs/disputeResolution.jsx"));
const AMLPolicy = lazy(() => import("./pages/docs/amlPolicy.jsx"));
const SelfExclusion = lazy(() => import("./pages/docs/selfExclusion.jsx"));
const MediaCenter = lazy(() => import("./pages/docs/mediaCenter.jsx"));
const AffiliateProgram = lazy(() => import("./pages/docs/affiliateProgram.jsx"));
const CookiesPolicy = lazy(() => import("./pages/docs/cookiesPolicy.jsx"));
const FAQ = lazy(() => import("./pages/docs/faq.jsx"));
const BonusTermsAndConditions = lazy(() => import("./pages/docs/bonusTermsAndConditions.jsx"));
const TermsOfService = lazy(() => import("./pages/docs/termsOfService.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalData = lazy(
	() => import("./pages/docs/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);
const HesapOdemeVeBonuslar = lazy(() => import("./pages/docs/turkish/hesapOdemeVeBonuslar.jsx"));
const UyusmazlikCozumu = lazy(() => import("./pages/docs/turkish/uyusmazlikCozumu.jsx"));
const AMLPolitikasi = lazy(() => import("./pages/docs/turkish/amlPolitikasi.jsx"));
const SikcaSorulanSorular = lazy(() => import("./pages/docs/turkish/sikcaSorulanSorular.jsx"));
const SorumluOyun = lazy(() => import("./pages/docs/turkish/sorumluOyun.jsx"));
const KYCPolitikalariGizlilikKisiselVeriYonetimi = lazy(
	() => import("./pages/docs/turkish/kycPolitikalariGizlilikKisiselVeriYonetimi.jsx")
);

const AffiliateProgramPt = lazy(() => import("./pages/docs/portuguese/affiliateProgram.jsx"));
const ContactUsPt = lazy(() => import("./pages/docs/portuguese/contactUs.jsx"));
const CookiesPolicyPt = lazy(() => import("./pages/docs/portuguese/cookiesPolicy.jsx"));
const FAQPt = lazy(() => import("./pages/docs/portuguese/faq.jsx"));
const ResponsibleGamingPt = lazy(() => import("./pages/docs/portuguese/responsibleGaming.jsx"));
const BonusTermsAndConditionsPt = lazy(
	() => import("./pages/docs/portuguese/bonusTermsAndConditions.jsx")
);
const TermsOfServicePt = lazy(() => import("./pages/docs/portuguese/termsOfService.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalDataPt = lazy(
	() => import("./pages/docs/portuguese/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);

const AccountsPayoutsAndBonusesMx = lazy(
	() => import("./pages/docs/mx/accountPayoutsAndBonuses.jsx")
);
const AffiliateProgramMx = lazy(() => import("./pages/docs/mx/affiliateProgram.jsx"));
const FairnessRNGTestingMethodsMx = lazy(
	() => import("./pages/docs/mx/fairnessRngTestingMethods.jsx")
);
const DisputeResolutionMx = lazy(() => import("./pages/docs/mx/disputeResolution.jsx"));
const AMLPolicyMx = lazy(() => import("./pages/docs/mx/amlPolicy.jsx"));
const SelfExclusionMx = lazy(() => import("./pages/docs/mx/selfExclusion.jsx"));
const ContactUsMx = lazy(() => import("./pages/docs/mx/contactUs.jsx"));
const CookiesPolicyMx = lazy(() => import("./pages/docs/mx/cookiesPolicy.jsx"));
const FAQMx = lazy(() => import("./pages/docs/mx/faq.jsx"));
const ResponsibleGamingMx = lazy(() => import("./pages/docs/mx/responsibleGaming.jsx"));
const BonusTermsAndConditionsMx = lazy(() =>
	window.TENANT === "novero"
		? import("./pages/docs/mx/bonusTermsAndConditions-novero.jsx")
		: import("./pages/docs/mx/bonusTermsAndConditions.jsx")
);
const TermsOfServiceMx = lazy(() => import("./pages/docs/mx/termsOfService.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalDataMx = lazy(
	() => import("./pages/docs/mx/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);

const AffiliateProgramBr = lazy(() => import("./pages/docs/brazil/affiliateProgram.jsx"));
const ContactUsBr = lazy(() => import("./pages/docs/brazil/contactUs.jsx"));
const CookiesPolicyBr = lazy(() => import("./pages/docs/brazil/cookiesPolicy.jsx"));
const FAQBr = lazy(() => import("./pages/docs/brazil/faq.jsx"));
const ResponsibleGamingBr = lazy(() => import("./pages/docs/brazil/responsibleGaming.jsx"));
const BonusTermsAndConditionsBr = lazy(
	() => import("./pages/docs/brazil/bonusTermsAndConditions.jsx")
);
const TermsOfServiceBr = lazy(() => import("./pages/docs/brazil/termsOfService.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalDataBr = lazy(
	() => import("./pages/docs/brazil/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);

const BonusTermsAndConditionsRu = lazy(
	() => import("./pages/docs/russian/bonusTermsAndConditions.jsx")
);
const ContactUsRu = lazy(() => import("./pages/docs/russian/contactUs.jsx"));
const CookiesPolicyRu = lazy(() => import("./pages/docs/russian/cookiesPolicy.jsx"));
const FAQRu = lazy(() => import("./pages/docs/russian/faq.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalDataRu = lazy(
	() => import("./pages/docs/russian/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);
const ResponsibleGamingRu = lazy(() => import("./pages/docs/russian/responsibleGaming.jsx"));
const TermsOfServiceRu = lazy(() => import("./pages/docs/russian/termsOfService.jsx"));

const AffiliateProgramTh = lazy(() => import("./pages/docs/thai/affiliateProgram.jsx"));
const BonusTermsAndConditionsTh = lazy(
	() => import("./pages/docs/thai/bonusTermsAndConditions.jsx")
);
const ContactUsTh = lazy(() => import("./pages/docs/thai/contactUs.jsx"));
const CookiesPolicyTh = lazy(() => import("./pages/docs/thai/cookiesPolicy.jsx"));
const FAQTh = lazy(() => import("./pages/docs/thai/faq.jsx"));
const KYCPoliciesPrivacyManagementOfPersonalDataTh = lazy(
	() => import("./pages/docs/thai/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);
const ResponsibleGamingTh = lazy(() => import("./pages/docs/thai/responsibleGaming.jsx"));
const TermsOfServiceTh = lazy(() => import("./pages/docs/thai/termsOfService.jsx"));

import {
	CasinoFavoritesPage,
	CasinoGameplayPage,
	CasinoHomePage,
	CasinoProviderPage,
} from "@pages/casino";

//Store - redux
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import configureStore, { history } from "./store.jsx";

//Util
import setAuthToken, { startTokenInterceptor } from "./utils/filter.jsx";

//Generic Alert poppup
import Alert from "./components/alert/index.js";

//Container
import { getAllContainers } from "./actions/cms";

// Chokwin imports
const ChokwinAccountsPayoutsAndBonuses = lazy(
	() => import("./pages/docs/chokwin/en/accountPayoutsAndBonuses.jsx")
);
const ChokwinGeneralTermsAndCnd = lazy(
	() => import("./pages/docs/chokwin/en/generalTermsAndCnd.jsx")
);
const ChokwinPrivacyPolicy = lazy(() => import("./pages/docs/chokwin/en/privacyPolicy.jsx"));
const ChokwinTermsOfService = lazy(() => import("./pages/docs/chokwin/en/termsOfService.jsx"));
const ChokwinAMLPolicy = lazy(() => import("./pages/docs/chokwin/en/amlPolicy.jsx"));
const ChokwinFAQ = lazy(() => import("./pages/docs/chokwin/en/faq.jsx"));
const ChokwinSelfExclusion = lazy(() => import("./pages/docs/chokwin/en/selfExclusion.jsx"));
const ChokwinDisputeResolution = lazy(
	() => import("./pages/docs/chokwin/en/disputeResolution.jsx")
);
const ChokwinResponsibleGaming = lazy(
	() => import("./pages/docs/chokwin/en/responsibleGaming.jsx")
);
const ChokwinBonusTermsAndConditions = lazy(
	() => import("./pages/docs/chokwin/en/bonusTermsAndConditions.jsx")
);
const ChokwinAccountPayoutsAndBonuses = lazy(
	() => import("./pages/docs/chokwin/en/accountPayoutsAndBonuses.jsx")
);
const ChokwinFairnessRngTestingMethods = lazy(
	() => import("./pages/docs/chokwin/en/fairnessRngTestingMethods.jsx")
);
const ChokwinKYCPoliciesPrivacyManagementOfPersonalData = lazy(
	() => import("./pages/docs/chokwin/en/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);

// Chokwin Thai imports
const ChokwinAccountsPayoutsAndBonusesTh = lazy(
	() => import("./pages/docs/chokwin/th/accountPayoutsAndBonuses.jsx")
);
const ChokwinGeneralTermsAndCndTh = lazy(
	() => import("./pages/docs/chokwin/th/generalTermsAndCnd.jsx")
);
const ChokwinPrivacyPolicyTh = lazy(() => import("./pages/docs/chokwin/th/privacyPolicy.jsx"));
const ChokwinTermsOfServiceTh = lazy(() => import("./pages/docs/chokwin/th/termsOfService.jsx"));
const ChokwinAMLPolicyTh = lazy(() => import("./pages/docs/chokwin/th/amlPolicy.jsx"));
const ChokwinFAQTh = lazy(() => import("./pages/docs/chokwin/th/faq.jsx"));
const ChokwinSelfExclusionTh = lazy(() => import("./pages/docs/chokwin/th/selfExclusion.jsx"));
const ChokwinDisputeResolutionTh = lazy(
	() => import("./pages/docs/chokwin/th/disputeResolution.jsx")
);
const ChokwinResponsibleGamingTh = lazy(
	() => import("./pages/docs/chokwin/th/responsibleGaming.jsx")
);
const ChokwinBonusTermsAndConditionsTh = lazy(
	() => import("./pages/docs/chokwin/th/bonusTermsAndConditions.jsx")
);
const ChokwinAccountPayoutsAndBonusesTh = lazy(
	() => import("./pages/docs/chokwin/th/accountPayoutsAndBonuses.jsx")
);
const ChokwinFairnessRngTestingMethodsTh = lazy(
	() => import("./pages/docs/chokwin/th/fairnessRngTestingMethods.jsx")
);
const ChokwinKYCPoliciesPrivacyManagementOfPersonalDataTh = lazy(
	() => import("./pages/docs/chokwin/th/kycPoliciesPrivacyManagementOfPersonalData.jsx")
);

//Layout changer
const AppRoute = ({
		component: Component,
		bottom: bottom,
		bottomSearch,
		layout: Layout,
		key,
		...rest
	}) => (
		<Route
			{...rest}
			render={(props) => (
				<Layout
					{...props}
					bottom={bottom != undefined ? bottom : true}
					bottomSearch={bottomSearch}>
					<Component
						{...props}
						key={key}
					/>
				</Layout>
			)}
		/>
	),
	store = configureStore();

//i18n
///handle missing lang we need to check localstorage lang first
let savedLanguage = localStorage.getItem("lang");

if (savedLanguage && !LANGUAGES.find((lang) => lang.code === savedLanguage)) {
	savedLanguage = window.DEFAULT_LANG;
}
//default lang set/check
if (!savedLanguage) {
	localStorage.setItem("lang", window.DEFAULT_LANG);
	document.title = window.TITLE[window.DEFAULT_LANG];
} else {
	document.title = window.TITLE[savedLanguage];
}
const onMissingTranslation = ({ translationId }) => translationId;
store.dispatch(
	initialize({
		languages: LANGUAGES,
		options: {
			onMissingTranslation,
			defaultLanguage: savedLanguage || window.DEFAULT_LANG,
			renderToStaticMarkup: false,
		},
	})
);
moment.locale(savedLanguage || "tr");
store.dispatch(addTranslationForLanguage(en, "en"));
store.dispatch(addTranslationForLanguage(tr, "tr"));
store.dispatch(addTranslationForLanguage(ru, "ru"));
store.dispatch(addTranslationForLanguage(pt, "pt"));
store.dispatch(addTranslationForLanguage(it, "it"));
store.dispatch(addTranslationForLanguage(es, "es"));
store.dispatch(addTranslationForLanguage(th, "th"));
store.dispatch(addTranslationForLanguage(br, "br"));
store.dispatch(addTranslationForLanguage(fa, "fa"));
store.dispatch(getAllContainers());
store.dispatch(getCurrencies());

//User Monitoring
import GAnalytic from "react-ga4";
import TagManager from "react-gtm-module";
GAnalytic.initialize(window.gaConfig);
TagManager.initialize({
	gtmId: window.gtagConfig,
});

// Set Existing Token
let userData = sessionStorage.getItem("user_data");
if (userData) {
	userData = JSON.parse(userData);
	setAuthToken(userData.token);
}
startTokenInterceptor(store);

//main context
import { resetActivityTimer, startReAuthTimer, stopReAuthTimer } from "@actions/auth";
import { getCurrencies } from "@actions/balance";
import CommonLoading from "@components/commonLoading";
import ChokwinLoading from "@components/commonLoading/chokwinLoading";
import VerificationPopup from "@layouts/v4/verificationPopup";
import ProfilePageV2 from "@pages/profile-v2";
import OldSportsbook from "@pages/sportsbook/old";
import Support from "@pages/support";
import { MainProvider } from "./context";
import { CookieProvider } from "./providers/cookies";

//Render method
render(
	<Provider store={store}>
		<MainProvider>
			<LocalizeProvider store={store}>
				<VerificationPopup>
					<ConnectedRouter history={history}>
						<Alert>
							<Router history={history}>
								<Suspense
									fallback={
										window.TENANT === "chokwin" ? (
											<ChokwinLoading />
										) : (
											<CommonLoading expanded={true} />
										)
									}>
									<CookieProvider>
										<Switch>
											<AppRoute
												exact
												path="/"
												layout={AppLayout}
												bottom={true}
												component={
													window.TENANT === "chokwin"
														? HomeChokwin
														: window.VERSION === "4"
															? HomeV4
															: window.VERSION === "2"
																? HomeV2
																: Home
												}
											/>
											<AppRoute
												exact
												path="/casino"
												layout={AppLayout}
												component={CasinoHomePage}
											/>
											<AppRoute
												exact
												path="/casino/game"
												layout={AppLayout}
												component={CasinoGameplayPage}
											/>
											<AppRoute
												exact
												path="/provider"
												layout={AppLayout}
												component={CasinoProviderPage}
											/>
											<AppRoute
												exact
												path="/casino-favorites"
												layout={AppLayout}
												component={CasinoFavoritesPage}
											/>
											<AppRoute
												exact
												path="/tv-games"
												layout={AppLayout}
												component={TVGames}
											/>
											<AppRoute
												exact
												path="/tv-games/:gid"
												layout={AppLayout}
												component={TVGames}
											/>
											<AppRoute
												exact
												path="/tv-games/:gid/:id/:provider"
												layout={AppLayout}
												component={TVGames}
											/>
											<AppRoute
												exact
												path="/bonus"
												layout={AppLayout}
												component={Bonus}
											/>
											<AppRoute
												exact
												path="/wiseodds"
												layout={AppLayout}
												component={Wiseodds}
											/>
											{window.SPORTSBOOK_VISIBLE && (
												<AppRoute
													exact
													path="/sportsbook"
													layout={AppLayout}
													bottomSearch={true}
													component={Sportsbook}
												/>
											)}
											<AppRoute
												exact
												path="/sportsbook-v2"
												layout={AppLayout}
												bottomSearch={true}
												component={OldSportsbook}
											/>
											{/* <AppRoute
										bottom={false}
										exact
										path="/profile/settings"
										layout={AppLayout}
										component={ProfileSettings}
									/> */}
											<AppRoute
												bottom={false}
												exact
												path="/profile/settings"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											{/* <AppRoute
										bottom={false}
										exact
										path="/profile/language"
										layout={AppLayout}
										component={LanguageSettings}
									/> */}
											{/* <AppRoute
										bottom={false}
										exact
										path="/profile/change-password"
										layout={AppLayout}
										component={ChangePassword}
									/> */}
											<AppRoute
												bottom={false}
												exact
												path="/profile/change-email"
												layout={AppLayout}
												component={ChangeEmail}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/security"
												layout={AppLayout}
												component={Security}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/history"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/documents"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/bonuses"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/deposit"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/withdraw"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												bottom={false}
												exact
												path="/profile/inbox"
												layout={AppLayout}
												component={ProfilePageV2}
											/>
											<AppRoute
												exact
												path="/docs/general-terms-and-conditions"
												layout={AppLayout}
												component={GeneralTermsAndCnd}
											/>
											<AppRoute
												exact
												path="/docs/privacy-policy"
												layout={AppLayout}
												component={PrivacyPolicy}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming"
												layout={AppLayout}
												component={ResponsibleGaming}
											/>
											<AppRoute
												exact
												path="/docs/bize-ulasin"
												layout={AppLayout}
												component={BizeUlasin}
											/>
											<AppRoute
												exact
												path="/docs/kullanim-sartlari"
												layout={AppLayout}
												component={KullanimSartlari}
											/>
											<AppRoute
												exact
												path="/docs/sik-sorulan-sorular"
												layout={AppLayout}
												component={SikSorulanSorular}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-programi"
												layout={AppLayout}
												component={Affiliate}
											/>
											<AppRoute
												exact
												path="/docs/accounts-payout-and-bonuses"
												layout={AppLayout}
												component={AccountsPayoutsAndBonuses}
											/>
											<AppRoute
												exact
												path="/docs/fairness-rng-testing-methods"
												layout={AppLayout}
												component={FairnessRNGTestingMethods}
											/>
											<AppRoute
												exact
												path="/docs/dispute-resolution"
												layout={AppLayout}
												component={DisputeResolution}
											/>
											<AppRoute
												exact
												path="/docs/aml-policy"
												layout={AppLayout}
												component={AMLPolicy}
											/>
											<AppRoute
												exact
												path="/docs/self-exclusion"
												layout={AppLayout}
												component={SelfExclusion}
											/>
											<AppRoute
												exact
												path="/docs/media-center"
												layout={AppLayout}
												component={MediaCenter}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-program"
												layout={AppLayout}
												component={AffiliateProgram}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-program-pt"
												layout={AppLayout}
												component={AffiliateProgramPt}
											/>
											<AppRoute
												exact
												path="/docs/contact-us-pt"
												layout={AppLayout}
												component={ContactUsPt}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy-pt"
												layout={AppLayout}
												component={CookiesPolicyPt}
											/>
											<AppRoute
												exact
												path="/docs/faq-pt"
												layout={AppLayout}
												component={FAQPt}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming-pt"
												layout={AppLayout}
												component={ResponsibleGamingPt}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions-pt"
												layout={AppLayout}
												component={BonusTermsAndConditionsPt}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service-pt"
												layout={AppLayout}
												component={TermsOfServicePt}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data-pt"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalDataPt
												}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-program-br"
												layout={AppLayout}
												component={AffiliateProgramBr}
											/>
											<AppRoute
												exact
												path="/docs/contact-us-br"
												layout={AppLayout}
												component={ContactUsBr}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy-br"
												layout={AppLayout}
												component={CookiesPolicyBr}
											/>
											<AppRoute
												exact
												path="/docs/faq-br"
												layout={AppLayout}
												component={FAQBr}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming-br"
												layout={AppLayout}
												component={ResponsibleGamingBr}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions-br"
												layout={AppLayout}
												component={BonusTermsAndConditionsBr}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service-br"
												layout={AppLayout}
												component={TermsOfServiceBr}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data-br"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalDataBr
												}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-program-mx"
												layout={AppLayout}
												component={AffiliateProgramMx}
											/>
											<AppRoute
												exact
												path="/docs/accounts-payout-and-bonuses-mx"
												layout={AppLayout}
												component={AccountsPayoutsAndBonusesMx}
											/>
											<AppRoute
												exact
												path="/docs/fairness-rng-testing-methods-mx"
												layout={AppLayout}
												component={FairnessRNGTestingMethodsMx}
											/>
											<AppRoute
												exact
												path="/docs/dispute-resolution-mx"
												layout={AppLayout}
												component={DisputeResolutionMx}
											/>
											<AppRoute
												exact
												path="/docs/aml-policy-mx"
												layout={AppLayout}
												component={AMLPolicyMx}
											/>
											<AppRoute
												exact
												path="/docs/self-exclusion-mx"
												layout={AppLayout}
												component={SelfExclusionMx}
											/>
											<AppRoute
												exact
												path="/docs/contact-us-mx"
												layout={AppLayout}
												component={ContactUsMx}
											/>
											<AppRoute
												exact
												path="/docs/faq-mx"
												layout={AppLayout}
												component={FAQMx}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions-mx"
												layout={AppLayout}
												component={BonusTermsAndConditionsMx}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service-mx"
												layout={AppLayout}
												component={TermsOfServiceMx}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy-mx"
												layout={AppLayout}
												component={CookiesPolicyMx}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming-mx"
												layout={AppLayout}
												component={ResponsibleGamingMx}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data-mx"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalDataMx
												}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions-ru"
												layout={AppLayout}
												component={BonusTermsAndConditionsRu}
											/>
											<AppRoute
												exact
												path="/docs/contact-us-ru"
												layout={AppLayout}
												component={ContactUsRu}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy-ru"
												layout={AppLayout}
												component={CookiesPolicyRu}
											/>
											<AppRoute
												exact
												path="/docs/faq-ru"
												layout={AppLayout}
												component={FAQRu}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data-ru"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalDataRu
												}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming-ru"
												layout={AppLayout}
												component={ResponsibleGamingRu}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service-ru"
												layout={AppLayout}
												component={TermsOfServiceRu}
											/>
											<AppRoute
												exact
												path="/docs/affiliate-program-th"
												layout={AppLayout}
												component={AffiliateProgramTh}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions-th"
												layout={AppLayout}
												component={BonusTermsAndConditionsTh}
											/>
											<AppRoute
												exact
												path="/docs/contact-us-th"
												layout={AppLayout}
												component={ContactUsTh}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy-th"
												layout={AppLayout}
												component={CookiesPolicyTh}
											/>
											<AppRoute
												exact
												path="/docs/faq-th"
												layout={AppLayout}
												component={FAQTh}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data-th"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalDataTh
												}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming-th"
												layout={AppLayout}
												component={ResponsibleGamingTh}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service-th"
												layout={AppLayout}
												component={TermsOfServiceTh}
											/>
											<AppRoute
												exact
												path="/docs/cookies-policy"
												layout={AppLayout}
												component={CookiesPolicy}
											/>
											<AppRoute
												exact
												path="/docs/faq"
												layout={AppLayout}
												component={FAQ}
											/>
											<AppRoute
												exact
												path="/docs/responsible-gaming"
												layout={AppLayout}
												component={ResponsibleGaming}
											/>
											<AppRoute
												exact
												path="/docs/bonus-terms-and-conditions"
												layout={AppLayout}
												component={BonusTermsAndConditions}
											/>
											<AppRoute
												exact
												path="/docs/terms-of-service"
												layout={AppLayout}
												component={TermsOfService}
											/>
											<AppRoute
												exact
												path="/docs/kyc-policies-privacy-management-of-personal-data"
												layout={AppLayout}
												component={
													KYCPoliciesPrivacyManagementOfPersonalData
												}
											/>
											<AppRoute
												exact
												path="/docs/hesap-odemeler-ve-bonuslar"
												layout={AppLayout}
												component={HesapOdemeVeBonuslar}
											/>
											<AppRoute
												exact
												path="/docs/uyusmazlik-cozumu"
												layout={AppLayout}
												component={UyusmazlikCozumu}
											/>
											<AppRoute
												exact
												path="/docs/aml-politikasi"
												layout={AppLayout}
												component={AMLPolitikasi}
											/>
											<AppRoute
												exact
												path="/docs/sikca-sorulan-sorular"
												layout={AppLayout}
												component={SikcaSorulanSorular}
											/>
											<AppRoute
												exact
												path="/docs/sorumlu-oyun"
												layout={AppLayout}
												component={SorumluOyun}
											/>
											<AppRoute
												exact
												path="/docs/hakkimizda"
												layout={AppLayout}
												component={Hakkimizda}
											/>
											<AppRoute
												exact
												path="/docs/basinda-mars-bahis"
												layout={AppLayout}
												component={BasindaMarsBahis}
											/>
											<AppRoute
												exact
												path="/docs/bizeulasin"
												layout={AppLayout}
												component={BizeUlasinReversed}
											/>
											<AppRoute
												exact
												path="/docs/odeme-yontemleri"
												layout={AppLayout}
												component={OdemeYontemleri}
											/>
											<AppRoute
												exact
												path="/docs/kullanimsartlari"
												layout={AppLayout}
												component={KullanimSartlariReversed}
											/>
											<AppRoute
												exact
												path="/docs/kyc-politikalari-gizlilik-kisisel-veri-yonetimi"
												layout={AppLayout}
												component={
													KYCPolitikalariGizlilikKisiselVeriYonetimi
												}
											/>
											{/* Chokwin English Routes */}
											<AppRoute
												exact
												path="/docs/chokwin/en/accounts-payout-and-bonuses"
												layout={AppLayout}
												component={ChokwinAccountsPayoutsAndBonuses}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/general-terms-and-conditions"
												layout={AppLayout}
												component={ChokwinGeneralTermsAndCnd}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/privacy-policy"
												layout={AppLayout}
												component={ChokwinPrivacyPolicy}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/terms-of-service"
												layout={AppLayout}
												component={ChokwinTermsOfService}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/aml-policy"
												layout={AppLayout}
												component={ChokwinAMLPolicy}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/faq"
												layout={AppLayout}
												component={ChokwinFAQ}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/self-exclusion"
												layout={AppLayout}
												component={ChokwinSelfExclusion}
											/>

											<AppRoute
												exact
												path="/docs/chokwin/en/dispute-resolution"
												layout={AppLayout}
												component={ChokwinDisputeResolution}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/responsible-gaming"
												layout={AppLayout}
												component={ChokwinResponsibleGaming}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/bonus-terms-and-conditions"
												layout={AppLayout}
												component={ChokwinBonusTermsAndConditions}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/account-payouts-and-bonuses"
												layout={AppLayout}
												component={ChokwinAccountPayoutsAndBonuses}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/fairness-rng-testing-methods"
												layout={AppLayout}
												component={ChokwinFairnessRngTestingMethods}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/en/kyc-policies-privacy-management-of-personal-data"
												layout={AppLayout}
												component={
													ChokwinKYCPoliciesPrivacyManagementOfPersonalData
												}
											/>

											{/* Chokwin Thai Routes */}
											<AppRoute
												exact
												path="/docs/chokwin/th/faq-th"
												layout={AppLayout}
												component={ChokwinFAQTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/privacy-policy-th"
												layout={AppLayout}
												component={ChokwinPrivacyPolicyTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/terms-of-service-th"
												layout={AppLayout}
												component={ChokwinTermsOfServiceTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/aml-policy-th"
												layout={AppLayout}
												component={ChokwinAMLPolicyTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/self-exclusion-th"
												layout={AppLayout}
												component={ChokwinSelfExclusionTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/dispute-resolution-th"
												layout={AppLayout}
												component={ChokwinDisputeResolutionTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/general-terms-and-conditions-th"
												layout={AppLayout}
												component={ChokwinGeneralTermsAndCndTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/responsible-gaming-th"
												layout={AppLayout}
												component={ChokwinResponsibleGamingTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/bonus-terms-and-conditions-th"
												layout={AppLayout}
												component={ChokwinBonusTermsAndConditionsTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/account-payouts-and-bonuses-th"
												layout={AppLayout}
												component={ChokwinAccountPayoutsAndBonusesTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/fairness-rng-testing-methods-th"
												layout={AppLayout}
												component={ChokwinFairnessRngTestingMethodsTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/kyc-policies-privacy-management-of-personal-data-th"
												layout={AppLayout}
												component={
													ChokwinKYCPoliciesPrivacyManagementOfPersonalDataTh
												}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/accounts-payout-and-bonuses-th"
												layout={AppLayout}
												component={ChokwinAccountsPayoutsAndBonusesTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/terms-of-service-th"
												layout={AppLayout}
												component={ChokwinTermsOfServiceTh}
											/>
											<Route
												exact
												path="/support">
												<Support />
											</Route>
											<AppRoute
												exact
												path="/docs/chokwin/th/responsible-gaming-th"
												layout={AppLayout}
												component={ChokwinResponsibleGamingTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/bonus-terms-and-conditions-th"
												layout={AppLayout}
												component={ChokwinBonusTermsAndConditionsTh}
											/>
											<AppRoute
												exact
												path="/docs/chokwin/th/kyc-policies-privacy-management-of-personal-data-th"
												layout={AppLayout}
												component={
													ChokwinKYCPoliciesPrivacyManagementOfPersonalDataTh
												}
											/>
											<AppRoute
												layout={AppLayout}
												component={NotFound}
											/>
										</Switch>
									</CookieProvider>
								</Suspense>
							</Router>
						</Alert>
					</ConnectedRouter>
				</VerificationPopup>
			</LocalizeProvider>
		</MainProvider>
	</Provider>,
	document.getElementById("app-route")
);

startReAuthTimer(store.dispatch);

history.listen(() => {
	resetActivityTimer();
});

window.addEventListener("userLogout", () => {
	stopReAuthTimer();
});
